import React, { forwardRef, useRef } from 'react';
import { Formik } from 'formik';
import AddressSearch from '../Address';
import { Waiter } from 'react-wait';

const AddressWrapped = (wrapperProps, ref) => {
  const name = wrapperProps.name || 'address';
  const v = {};
  v[name] = wrapperProps.value ? wrapperProps.value : {};

  const baseUrl =
    typeof wrapperProps.baseUrl !== 'undefined' ? wrapperProps.baseUrl : 'http://localhost:3000';

  const searchUrl = wrapperProps.searchUrl || '/api/addresses?term=';
  const addressDetailUrl = wrapperProps.addressDetailUrl || '/api/addresses/';
  const validationUrl = wrapperProps.validationUrl || '/api/addresses/addressValidation2?address=';

  const newRef = ref ?? useRef();

  return (
    <Waiter>
      <Formik initialValues={v} validate={() => {}} onSubmit={() => {}}>
        {props => {
          return (
            <AddressSearch
              id={wrapperProps.id}
              autoValidate={wrapperProps.autoValidate}
              onValidating={wrapperProps.onValidating}
              label={wrapperProps.label}
              helpMessage={wrapperProps.helpMessage}
              labelComp={wrapperProps.labelComp}
              placeholder={wrapperProps.placeholder}
              searchUrl={`${baseUrl}${searchUrl}`}
              addressDetailUrl={`${baseUrl}${addressDetailUrl}`}
              validationUrl={`${baseUrl}${validationUrl}`}
              ref={newRef}
              {...props}
              name={name}
              isValidating
              onChange={wrapperProps.onChange}
              onSelect={wrapperProps.onSelect}
              onDetailsRetrieved={wrapperProps.onDetailsRetrieved}
              onLoading={wrapperProps.onLoading}
              onErrors={wrapperProps.onErrors}
              onManualChange={wrapperProps.onManualChange}
              onWarningChange={wrapperProps.onWarningChange}
              onValidationChange={wrapperProps.onValidationChange}
              international={wrapperProps.international}
              customManual={wrapperProps.customManual}
              classNames={wrapperProps.classNames}
              apiKeyName={wrapperProps.apiKeyName}
              showErrors={wrapperProps.showErrors}
              countries={wrapperProps.countries}
            />
          );
        }}
      </Formik>
    </Waiter>
  );
};

export default forwardRef(AddressWrapped);
